// extracted by mini-css-extract-plugin
export default {"breadcrumb":"wi-z","breadcrumbItem":"xi-z","hideOnMobile":"yi-z"};